var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#434c56","d":"M31.967 6.993l-15.96 15.961-7.974-7.974-5 5 12.891 13.027 21.043-21.014-5-5z"}));
}

Check.defaultProps = {"viewBox":"0 0 40 40","className":"version-optionals__item__icon version-optionals__item__icon--standard icon color--grey-700"};

module.exports = Check;

Check.default = Check;
